module.exports = __webpack_public_path__ + "img/ic_my_wallet.b2786c20.svg";